import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  extractPNA(pnaNo: string): {
    pnaNo: string | null;
    PnaYear: string | number;
  } {
    if (!pnaNo) {
      return { pnaNo: null, PnaYear: 0 };
    }
    const match = pnaNo.match(/(\d+)-(\d+)/);
    if (match) {
      return {
        pnaNo: match[1],
        PnaYear: parseInt(match[2]),
      };
    }
    return { pnaNo: pnaNo, PnaYear: pnaNo };
  }
}
